import React, { Fragment, useEffect } from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Login from "./components/oauth/Login"
import Logout from "./components/oauth/Logout";

import Dashboard from "./components/dashboard";

import Authorized from "./components/authorized";

import Businesses from "./components/businesses/List";
import CreateBusinesses from "./components/businesses/Create";

import Warranties from "./components/warranties/List";
import CreateWarranties from "./components/warranties/Create";

import Brands from "./components/brands/List";
import CreateBrands from "./components/brands/Create";

import Bundles from "./components/bundles/List";
import CreateBundles from "./components/bundles/Create";

import AttributeCategories from "./components/attribute_categories/List";
import CreateAttributeCategories from "./components/attribute_categories/Create";

import Attributes from "./components/attributes/List";
import CreateAttributes from "./components/attributes/Create";

import AttributeItems from "./components/attribute_items/List";
import CreateAttributeItems from "./components/attribute_items/Create";

import ProductCategories from "./components/product_categories/List";
import CreateProductCategories from "./components/product_categories/Create";

import Rewards from "./components/rewards/List";
import CreateRewards from "./components/rewards/Create";

import RewardRules from "./components/reward_rules/List";
import CreateRewardRules from "./components/reward_rules/Create";

import Tags from "./components/tags/List";
import CreateTags from "./components/tags/Create";

import Contents from "./components/contents/List";
import CreateContents from "./components/contents/Create";

import Sliders from "./components/sliders/List";
import CreateSliders from "./components/sliders/Create";

import FaqCategories from "./components/faq_categories/List";
import CreateFaqCategories from "./components/faq_categories/Create";

import Faqs from "./components/faqs/List";
import CreateFaqs from "./components/faqs/Create";

import Vouchers from "./components/vouchers/List";
import CreateVouchers from "./components/vouchers/Create";

import Periodics from "./components/periodics/List";
import CreatePeriodics from "./components/periodics/Create";

import CartSettings from "./components/cart_settings/List";
import CreateCartSettings from "./components/cart_settings/Create";

import DeliveryDays from "./components/delivery_days/List";

import Invoices from "./components/invoices/List";
import FinancialReport from "./components/invoices/Financial";
import Report from "./components/invoices/Report";
import ProductReport from "./components/invoices/Product";

import Shippings from "./components/shippings/List";
import CreateShippings from "./components/shippings/Create";

import Wholesales from "./components/wholesales/List";
import CreateWholesales from "./components/wholesales/Create";

import WholesaleRules from "./components/wholesale_rules/List";
import CreateWholesaleRules from "./components/wholesale_rules/Create";

import WholesaleShippings from "./components/wholesale_shippings/List";
import CreateWholesaleShippings from "./components/wholesale_shippings/Create";

import WholesaleRequests from "./components/wholesale_requests/List";

import Users from "./components/users/List";
import CreateUsers from "./components/users/Create";

import Roles from "./components/roles/List";
import CreateRoles from "./components/roles/Create";

import Notifications from "./components/notifications/List";

import Profile from "./components/profile/User";

import Contact from "./components/profile/Contact";

import Business from "./components/profile/Business";

import Products from "./components/products/ProductUser";
import ProductsCreate from "./components/products/ProductUserCreate";
import ProductsPriceCreate from "./components/products/Price";
import ProductPrices from "./components/products/PriceList";

import Setting from "./components/settings";


import Layout from "./components";

import { useLocation } from 'react-router-dom';

import "preline/preline";

import NProgress from 'nprogress'

import 'nprogress/nprogress.css'
import Comment from "./components/products/Comment";
import CommentList from "./components/products/CommentList";

const App = () => {

  const location = useLocation();
  const searchParams = useSearchParams();

  useEffect(() => {
    window.HSStaticMethods.autoInit();
  }, [location.pathname]);

  useEffect(() => {
    const handleStart = () => {
      NProgress.start()
    }
    const handleStop = () => {
      NProgress.done()
    } 
    handleStop()
    return () => {
      handleStart()
    }
  }, [location.pathname, searchParams])
 

  return (
    <Fragment>
      <ToastContainer />
      <Routes>
        <Route index element={<Login />} />
        <Route path="/permission-error" element={<Authorized />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/" element={<Layout />}>

          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/businesses" element={<Businesses />} />
          <Route path="/businesses/create" element={<CreateBusinesses />} />
          <Route path="/businesses/create/:id" element={<CreateBusinesses />} />

          <Route path="/warranties" element={<Warranties />} />
          <Route path="/warranties/create" element={<CreateWarranties />} />
          <Route path="/warranties/create/:id" element={<CreateWarranties />} />

          <Route path="/brands" element={<Brands />} />
          <Route path="/brands/create" element={<CreateBrands />} />
          <Route path="/brands/create/:id" element={<CreateBrands />} />

          <Route path="/bundles" element={<Bundles />} />
          <Route path="/bundles/create" element={<CreateBundles />} />
          <Route path="/bundles/create/:id" element={<CreateBundles />} />

          <Route path="/attribute_categories" element={<AttributeCategories />} />
          <Route path="/attribute_categories/create" element={<CreateAttributeCategories />} />
          <Route path="/attribute_categories/create/:id" element={<CreateAttributeCategories />} />

          <Route path="/attributes" element={<Attributes />} />
          <Route path="/attributes/create" element={<CreateAttributes />} />
          <Route path="/attributes/create/:id" element={<CreateAttributes />} />

          <Route path="/attribute_items" element={<AttributeItems />} />
          <Route path="/attribute_items/create" element={<CreateAttributeItems />} />
          <Route path="/attribute_items/create/:id" element={<CreateAttributeItems />} />

          <Route path="/product_categories" element={<ProductCategories />} />
          <Route path="/product_categories/create" element={<CreateProductCategories />} />
          <Route path="/product_categories/create/:id" element={<CreateProductCategories />} />


          <Route path="/rewards" element={<Rewards />} />
          <Route path="/rewards/create" element={<CreateRewards />} />
          <Route path="/rewards/create/:id" element={<CreateRewards />} />

          <Route path="/reward_rules" element={<RewardRules />} />
          <Route path="/reward_rules/create" element={<CreateRewardRules />} />
          <Route path="/reward_rules/create/:id" element={<CreateRewardRules />} />

          <Route path="/tags" element={<Tags />} />
          <Route path="/tags/create" element={<CreateTags />} />
          <Route path="/tags/create/:id" element={<CreateTags />} />

          <Route path="/contents" element={<Contents />} />
          <Route path="/contents/create" element={<CreateContents />} />
          <Route path="/contents/create/:id" element={<CreateContents />} />

          <Route path="/sliders" element={<Sliders />} />
          <Route path="/sliders/create" element={<CreateSliders />} />
          <Route path="/sliders/create/:id" element={<CreateSliders />} />

          <Route path="/faq_categories" element={<FaqCategories />} />
          <Route path="/faq_categories/create" element={<CreateFaqCategories />} />
          <Route path="/faq_categories/create/:id" element={<CreateFaqCategories />} />

          <Route path="/faqs" element={<Faqs />} />
          <Route path="/faqs/create" element={<CreateFaqs />} />
          <Route path="/faqs/create/:id" element={<CreateFaqs />} />

          <Route path="/vouchers" element={<Vouchers />} />
          <Route path="/vouchers/create" element={<CreateVouchers />} />
          <Route path="/vouchers/create/:id" element={<CreateVouchers />} />

          <Route path="/periodics" element={<Periodics />} />
          <Route path="/periodics/create" element={<CreatePeriodics />} />
          <Route path="/periodics/create/:id" element={<CreatePeriodics />} />

          <Route path="/cart_settings" element={<CartSettings />} />
          <Route path="/cart_settings/create" element={<CreateCartSettings />} />
          <Route path="/cart_settings/create/:id" element={<CreateCartSettings />} />

          <Route path="/delivery_days" element={<DeliveryDays />} />

          <Route path="/invoices" element={<Invoices />} />
          <Route path="/invoices/financial-report" element={<FinancialReport />} />
          <Route path="/invoices/report" element={<Report />} />
          <Route path="/invoices/product-report" element={<ProductReport />} />

          <Route path="/shippings" element={<Shippings />} />
          <Route path="/shippings/create" element={<CreateShippings />} />
          <Route path="/shippings/create/:id" element={<CreateShippings />} />

          <Route path="/wholesales" element={<Wholesales />} />
          <Route path="/wholesales/create" element={<CreateWholesales />} />
          <Route path="/wholesales/create/:id" element={<CreateWholesales />} />

          <Route path="/wholesale_rules" element={<WholesaleRules />} />
          <Route path="/wholesale_rules/create" element={<CreateWholesaleRules />} />
          <Route path="/wholesale_rules/create/:id" element={<CreateWholesaleRules />} />

          <Route path="/wholesale_shippings" element={<WholesaleShippings />} />
          <Route path="/wholesale_shippings/create" element={<CreateWholesaleShippings />} />
          <Route path="/wholesale_shippings/create/:id" element={<CreateWholesaleShippings />} />

          <Route path="/wholesale_requests" element={<WholesaleRequests />} />

          <Route path="/users" element={<Users />} />
          <Route path="/users/create" element={<CreateUsers />} />
          <Route path="/users/create/:id" element={<CreateUsers />} />

          <Route path="/roles" element={<Roles />} />
          <Route path="/roles/create" element={<CreateRoles />} />
          <Route path="/roles/create/:id" element={<CreateRoles />} />

          <Route path="/notifications" element={<Notifications />} />

          <Route path="/profile" element={<Profile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/business" element={<Business />} />

          <Route path="/products" element={<Products />} />
          <Route path="/products/prices" element={<ProductPrices />} />
          <Route path="/products/create" element={<ProductsCreate />} />
          <Route path="/products/create/:id" element={<ProductsCreate />} />
          <Route path="/products/price/:id" element={<ProductsPriceCreate />} />
          <Route path="/products/comment/all" element={<CommentList />} />
          <Route path="/products/comment/:id" element={<Comment />} />

          <Route path="/settings" element={<Setting />} />
          

          
        </Route>
      </Routes>
    </Fragment>
  )
}


export default App